// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_leverage_position_cell_loss {
  color: var(--danger);
}

.user_leverage_position_cell_gain {
  color: var(--success);
}

.modal-playlist-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(80, 67, 74, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.modal-playlist-container {
  background: var(--bg-card);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  position: relative;
  width: 1000px;
  height: 75%
}

.playlist-details {
  height: 90%;
}

.modal-playlist-overlay.open {
  opacity: 1;
  visibility: visible;
}

.modal-playlist-button-div{
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: start;
  width: 100%;
}

.modal-playlist-button-div .close{
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--bg-card);
  border: solid 1px black;
}

.modal-playlist_title{
  margin: 0 0 20px 0;
}

.close_margin_position_button {
  background-color: var(--primary);
  padding: 5px 20px;
  border-radius: 5px;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/ago/AgoUser/AgoDataArray/AgbkUserPositions/AgbkUserPositions.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".user_leverage_position_cell_loss {\n  color: var(--danger);\n}\n\n.user_leverage_position_cell_gain {\n  color: var(--success);\n}\n\n.modal-playlist-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(80, 67, 74, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n}\n\n.modal-playlist-container {\n  background: var(--bg-card);\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n  position: relative;\n  width: 1000px;\n  height: 75%\n}\n\n.playlist-details {\n  height: 90%;\n}\n\n.modal-playlist-overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.modal-playlist-button-div{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: start;\n  width: 100%;\n}\n\n.modal-playlist-button-div .close{\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--bg-card);\n  border: solid 1px black;\n}\n\n.modal-playlist_title{\n  margin: 0 0 20px 0;\n}\n\n.close_margin_position_button {\n  background-color: var(--primary);\n  padding: 5px 20px;\n  border-radius: 5px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: bold;\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
